// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-select-type-account {
  width: 100%;
  background: #FFFFFF;
  border: 0.5px solid #C9D4DF;
  border-radius: 12px;
  font-weight: 400;
  font-size: 20px;
  letter-spacing: -0.510417px;
  color: #44474B;
  margin: 30px 0 0 0;
  height: 80px;
  box-shadow: 0px 1px 1px rgba(0, 51, 102, 0.05);
}

.btn-select-type-account:focus, .btn-selected {
  border: 3px solid #43B02A;
  background: #FFFFFF;
  color: #43B02A;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.05), 0px 3px 6px 0px rgba(0, 0, 0, 0.05);
}

.btn {
  box-shadow: none;
}

.form-group-button {
  margin: 120px 0 20px 0;
}

.wc-container .wc-container-in .form-group-button {
  margin: 200px 0 10px 0;
}
.wc-container .wc-container-in .form-group-button .btn-secondary:disabled {
  color: #fff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
